import { getCurrentInstance, ref } from '@vue/composition-api';
export function useForm(initialValues) {
    const vue = getCurrentInstance()?.proxy || {
        $v: {
            $reset: () => console.warn(`$reset attempted on form like ${initialValues}`),
            $touch: () => console.warn(`$touch attempted on form like ${initialValues}`),
            $invalid: false,
        },
    };
    const defaultForm = { ...initialValues };
    const form = ref({ ...defaultForm });
    const setForm = (newForm) => {
        if (!newForm) {
            form.value = { ...defaultForm };
        }
        else {
            form.value = { ...newForm };
        }
        vue.$v.$reset();
    };
    const invalid = () => {
        vue.$v.$touch();
        return vue.$v.$invalid || false;
    };
    return { form, setForm, invalid };
}
